import { render, staticRenderFns } from "./SeriesCourses.vue?vue&type=template&id=7ea8ed39&scoped=true"
import script from "./SeriesCourses.vue?vue&type=script&lang=js"
export * from "./SeriesCourses.vue?vue&type=script&lang=js"
import style0 from "./SeriesCourses.vue?vue&type=style&index=0&id=7ea8ed39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea8ed39",
  null
  
)

export default component.exports